(function () {
    'use strict';

    /*
     MyOrderDetailsController
    -------------------------------------------------------------------------- */

    angular
        .module('PublicApp.Order.details', [])
        .controller('MyOrderDetailsController', [
            '$scope',
            '__Form',
            '__Utils',
            'appServices',
            '__DataStore',
            MyOrderDetailsController
        ]);

    /**
      * MyOrderDetailsController for manage product list
      *
      * @inject $scope
      * @inject __Form
      * @inject __Utils
      * 
      * @return void
      *-------------------------------------------------------- */


    function MyOrderDetailsController($scope, __Form, __Utils, appServices, __DataStore) {

        var scope = this;
        scope.pageStatus = false;

        // Get order details
        scope.orderData = __globals.getAppJSItem('orderDetails');

        var requestedData = scope.orderData.data;
        scope.billingAddress = requestedData.address.billingAddress;
        scope.shippingAddress = requestedData.address.shippingAddress;
        scope.sameAddress = requestedData.address.sameAddress;

        scope.user = requestedData.user;
        scope.order = requestedData.order;
        scope.orderStatus = requestedData.order.orderStatus;
        scope.orderProducts = requestedData.orderProducts;
        scope.coupon = requestedData.coupon;
        scope.taxes = requestedData.taxes;
        scope.shipping = requestedData.shipping;

        scope.pageStatus = true;

        /**
          * If user order payment is pending then he will allow to update
          * his payment using PayPal
          *
          * @param string orderUID
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.updatePayment = function (orderUID) {

            __globals.redirectBrowser(__Utils.apiURL('order.paypal.checkout', {
                'orderUID': orderUID
            }));
        };

        /**
          * Contact to store/Admin Dialog
          * 
          * @return void
          *---------------------------------------------------------------- */

        scope.contactStoreDialog = function (orderUID) {

            appServices.showDialog({

                orderUID: orderUID
            },
                {
                    templateUrl: __globals.getTemplateURL('order.user.contact-store')
                },
                function (promiseObj) { });
        };

        /**
          * Delete address 
          *
          * @param number orderId
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.cancelOrder = function (orderId) {

            __globals.showConfirmation({
                text: __globals.getJSString('order_cancellation_text'),
                confirmButtonText: __globals.getJSString('cancel_action_button_text')
            },
                function () {

                    __DataStore.post({
                        'apiURL': 'order.user.cancellation_process',
                        'orderID': orderId,
                    })
                        .success(function (responseData) {

                            var message = responseData.data.message;

                            appServices.processResponse(responseData, {
                                error: function (data) {
                                    __globals.showConfirmation({
                                        title: __globals.getJSString('cancel_error_title'),
                                        text: message,
                                        type: 'error'
                                    });

                                }
                            },
                                function (data) {

                                    __globals.showConfirmation({
                                        title: __globals.getJSString('cancel_success_title'),
                                        text: message,
                                        type: 'success'
                                    });

                                    scope.order.allowOrderCancellation = false;
                                    scope.order.orderStatus = 3;
                                    scope.order.formatedOrderStatus = 'Cancelled';

                                }
                            );

                        });

                });

        };
    };

})();